import Keyword from './Keyword'
import Chemical from './Chemical'
import Drug from './Drug'
import InteractionType from './InteractionType'
import Interaction from './Interaction'
import Probability from './Probability'
import PreRegistration from './PreRegistration'
import ImageTime from './ImageTime'
import Cids from './Cids'
import BookVectorization from './BookVectorization'

export {
  Keyword,
  PreRegistration,
  Chemical,
  Drug,
  InteractionType,
  Interaction,
  Probability,
  ImageTime,
  Cids,
  BookVectorization,
}



// WEBPACK FOOTER //
// ./src/icons/index.js